export const WORK_APPROVAL_STATUSES = Object.freeze({
  NOT_APPROVED: "NOT_APPROVED",
  APPROVED: "APPROVED",
  REVOKED_APPROVAL: "REVOKED_APPROVAL",
});

export const WORK_APPROVAL_STATUS_OPTIONS = Object.freeze([
  {
    value: WORK_APPROVAL_STATUSES.NOT_APPROVED,
    translationKey: "works.work_approval.not_approved",
    className: "pending",
  },
  {
    value: WORK_APPROVAL_STATUSES.APPROVED,
    translationKey: "works.work_approval.approved",
    className: "approved",
  },
  {
    value: WORK_APPROVAL_STATUSES.REVOKED_APPROVAL,
    translationKey: "works.work_approval.revoked_approval",
    className: "revoked",
  },
]);

export function getWorkApprovalStatusOption(status) {
  return WORK_APPROVAL_STATUS_OPTIONS.find((option) => option.value === status) || WORK_APPROVAL_STATUS_OPTIONS[0];
}